
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import type { Candidate } from "../types";
import { DatePickerField } from "./fields/DatePickerField";
import { TooltipField } from "./fields/TooltipField";
import { useHiredCandidateForm } from "./hooks/useHiredCandidateForm";

interface HiredCandidateFormProps {
  candidate: Candidate;
  isOpen: boolean;
  onClose: () => void;
  onSave: (updatedCandidate: Candidate) => void;
}

export const HiredCandidateForm = ({ candidate, isOpen, onClose, onSave }: HiredCandidateFormProps) => {
  const {
    startDate,
    setStartDate,
    contractLength,
    setContractLength,
    placementFee,
    setPlacementFee,
    acceptedDate,
    setAcceptedDate,
    guaranteeEndDate,
    setGuaranteeEndDate,
    handleSubmit,
  } = useHiredCandidateForm({ candidate, onSave, onClose });

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Complete Hiring Details</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <DatePickerField
            label="Offer Accepted Date"
            value={acceptedDate}
            onChange={setAcceptedDate}
          />

          <DatePickerField
            label="Start Date"
            value={startDate}
            onChange={setStartDate}
          />

          <div className="space-y-2">
            <Input
              id="contractLength"
              value={contractLength}
              onChange={(e) => setContractLength(e.target.value)}
              placeholder="e.g., 6 months, 1 year"
            />
          </div>

          <TooltipField
            label="Placement Fee"
            tooltipContent="The commission or revenue generated from this candidate's placement. This will be automatically added to revenue tracking."
          >
            <Input
              id="placementFee"
              type="number"
              value={placementFee}
              onChange={(e) => setPlacementFee(e.target.value)}
              placeholder="Enter placement fee"
            />
          </TooltipField>

          <TooltipField
            label="Guarantee End Date"
            tooltipContent="The date until which the placement is guaranteed. If the candidate leaves before this date, a replacement may be required."
          >
            <DatePickerField
              label=""
              value={guaranteeEndDate}
              onChange={setGuaranteeEndDate}
            />
          </TooltipField>

          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit">Save Details</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

